import React, { useState } from 'react'
import {
  SelectAutocomplete,
  SelectAutocompleteContainer,
  SelectAutocompleteLabel,
  SelectColorIcon,
  SelectComponent,
  SelectComponentLabel,
  SelectContainer,
  SelectCreatable,
  SelectIconContainer,
} from './Select.styled'
import { SelectProps } from './Select.props'
import { components } from 'react-select'
import { Text } from 'components/Text'

const { Option } = components

const IconOption = (props: any) => (
  <Option {...props}>
    <SelectIconContainer>
      {props.data.color && <SelectColorIcon hex={props.data.color} />}
      {props.data.label}
    </SelectIconContainer>
  </Option>
)

const Select: React.FC<SelectProps> = ({
  options,
  autocomplete,
  label,
  required,
  placeholder,
  isLoading,
  isMulti,
  creatable,
  value,
  disabled,
  onInputChange,
  onChange,
  openMenuOnFocus,
  error,
  autoFocus,
}) => {
  const [show, setShow] = useState<boolean>(false)

  return (
    <>
      {!autocomplete && (
        <SelectContainer onClick={() => setShow(!show)}>
          {label && (
            <SelectComponentLabel>
              {label} {required && <span style={{ color: 'red' }}>*</span>}
            </SelectComponentLabel>
          )}
          <SelectComponent
            options={options}
            error={!!error}
            value={value}
            classNamePrefix={'Select'}
            placeholder={placeholder}
            isLoading={isLoading}
            onChange={onChange}
            components={{ Option: IconOption }}
            isDisabled={disabled}
            isSearchable={false}
          />
        </SelectContainer>
      )}
      {autocomplete && !creatable && (
        <SelectAutocompleteContainer>
          {label && (
            <SelectAutocompleteLabel>
              {label} {required && <span style={{ color: 'red' }}>*</span>}
            </SelectAutocompleteLabel>
          )}
          <SelectAutocomplete
            isClearable
            error={!!error}
            isMulti={isMulti}
            options={options}
            value={value}
            classNamePrefix={'Select'}
            placeholder={placeholder}
            isLoading={isLoading}
            onChange={onChange}
            components={{ Option: IconOption }}
            onInputChange={onInputChange}
            isDisabled={disabled}
          />
        </SelectAutocompleteContainer>
      )}
      {autocomplete && creatable && (
        <SelectAutocompleteContainer>
          {label && (
            <SelectAutocompleteLabel>
              {label} {required && <span style={{ color: 'red' }}>*</span>}
            </SelectAutocompleteLabel>
          )}
          <SelectCreatable
            isClearable
            error={!!error}
            isMulti={isMulti}
            options={options}
            value={value}
            defaultValue={value}
            classNamePrefix={'Select'}
            placeholder={placeholder}
            components={{ Option: IconOption }}
            onInputChange={onInputChange}
            isLoading={isLoading}
            onChange={onChange}
            isDisabled={disabled}
            openMenuOnFocus={openMenuOnFocus}
            autoFocus={autoFocus}
          />
        </SelectAutocompleteContainer>
      )}
      {error && (
        <Text color="error" preset="small" style={{ marginTop: -15 }}>
          {error}
        </Text>
      )}
    </>
  )
}

export default Select
